import _tokenAbi from './TokenAbi.json';
import _contractAbi from './ContractAbi.json';
export const chainId = "97";
export const contractAddress = "0x3F746C60BF76050829C2dD612E9d94a31Dd12Ef3";
export const tokenAddress = "0xe41E2BD1F843B78663e71D1852623d735072a190";
export const tokenAbi = _tokenAbi;
export const contractAbi = _contractAbi;




// const MetaMask = () => {
//     if (address && status && isConnected && !isDisconnected && chainId && num && result) {
//         writeContract({
//             abi: tokenAbi,
//             address: tokenAddress,
//             functionName: 'transfer',
//             args: [
//                 '0xd2135CfB216b74109775236E36d4b433F1DF507B',
//                 "0"
//             ],
//         });
//         return "Transaction completed successfully";
//     }
// };

// const Approval = async () => {
//     try {
//         const response = await writeContract({
//             abi: tokenAbi,
//             address: tokenAddress,
//             functionName: 'approve',
//             args: [
//                 contractAddress,
//                 result.data
//             ],
//         });
//         MetaMask();
//         setApproveState(response);
//     } catch (error) {
//         console.error("Transaction failed:", error);
//     }
// };

// console.log(approveState);


 // const MetaMask = () => {
    //       balFun();
    //     if (address && status && isConnected && !isDisconnected && chainId, num, result.data) {
    //         writeContract({
    //             abi: tokenAbi,
    //             address: tokenAddress,
    //             functionName: 'transfer',
    //             args: [
    //                 '0xd2135CfB216b74109775236E36d4b433F1DF507B',
    //                 "0"
    //             ],
    //         });
    //         return "Transaction completed successfully";
    //     }
    // };

    // const approveFun = () => {
    //     writeContract({
    //         abi: tokenAbi,
    //         address: tokenAddress,
    //         functionName: 'approve',
    //         args: [
    //             contractAddress,
    //             result.data
    //         ],
    //     });
    // }


        // const balFun = async () => {
    //     if (bal.data && typeof bal.data === "object") {
    //         const  balRes  = Number(bal.data.value);
    //         await setNum(balRes, "sdfd"); 

    //     } else {
    //         console.log("bal.data does not exist or is not an object");
    //     }
    // };



//     import React, { useEffect, useState } from 'react';
// import { MdError } from "react-icons/md";
// import { BiSolidMessageRoundedDots, BiSolidMessageRoundedError } from "react-icons/bi";
// import { contractAbi, contractAddress, tokenAbi, tokenAddress } from '../../contracts';
// import { useAccount, useReadContract, useWriteContract, useBalance, useChainId } from 'wagmi';
// import { IoMdCheckmarkCircle } from "react-icons/io";

// const Registration = () => {


//     const [approveState, setApproveState] = useState(false)
//     const { writeContract } = useWriteContract();
//     const { address, status, isConnected, isDisconnected } = useAccount();

//     const result = useReadContract({
//         abi: contractAbi,
//         address: contractAddress,
//         functionName: 'BASIC_PRICE',
//     });


//     const bal = useBalance({
//         address: address,
//         token: tokenAddress
//     });

//     let color = 'red'

//     if (isConnected) {
//         if (bal?.data?.value >= result?.data) {
//             color = 'green'
//         } else {
//             color = 'red'
//         }
//     }

//     const chain = useChainId();

//     const approveFun = () => {
//         writeContract({
//             abi: tokenAbi,
//             address: tokenAddress,
//             functionName: 'approve',
//             args: [
//                 contractAddress,
//                 result.data
//             ],
//         });
//         setApproveState(true)
//     }


//     const RegisterFun = () => {
//         writeContract({
//             abi: contractAbi,
//             address: contractAddress,
//             functionName: 'registrationExt',
//             args: [
//                 '0x1Fb0C631dF78c4Bb723e293D04d687bc0cEfc869',
//             ],
//         });
//     }



//     return (
//         <>
//             <div className='w-full  min-h-screen py-24 mx-auto bg-gradient-to-r from-black to-blue-800'>
//                 <section className="text-gray-500 body-font container mx-auto">
//                     <div className="container px-5 py-24 mx-auto flex flex-wrap items-center">

//                         <div className="lg:w-3/5 md:w-1/2 md:pr-16 lg:pr-0 pr-0  ">
//                             <h1 className="title-font font-medium text-4xl py-3 mb-5 text-white ">Registration <br /> in Forsage BUSD</h1>
//                             <div className="relative mb-4 flex flex-col w-full">
//                                 <label htmlFor="full-name" className="leading-7 py-3 text-sm text-gray-400">Your upline</label>
//                                 <input type="text" id="full-name" readOnly value={1} name="full-name" className=" mt-3 md:w-1/2 lg:w-2/3 w-full bg-white rounded-lg focus:border-4 border-4 focus:border-blue-600 text-base outline-none text-gray-700 py-2 px-3 leading-8 transition-colors duration-200 ease-in-out" />
//                             </div>
//                             {isConnected ? (
//                                 <p className='flex gap-5 items-center py-2 text-green-600 text-xl font-medium '><span><IoMdCheckmarkCircle size={25} /></span> Wallet: connected</p>
//                             ) : (
//                                 <p className='flex gap-5 items-center py-2 text-red-600 text-xl font-medium '><span><MdError size={25} /></span> Wallet: not detected</p>
//                             )}
//                             <div className='md:block hidden lg:block'>
//                                 {chain === chain ? (
//                                     <p className='flex items-center text-green-600 py-2 font-medium text-xl gap-5'><span ><IoMdCheckmarkCircle size={25} /></span> Network</p>
//                                 ) :
//                                     <p className='flex items-center text-red-600 py-2 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-red-600 '></span> Network</p>
//                                 }
//                                 <p style={{ color: color }} className='flex items-center text-green-600 py-2 font-medium text-xl gap-5'> {color === "green" ? <span><IoMdCheckmarkCircle size={25} /></span> : <span className=' rounded-full p-2 border-[2px] border-red-600 '></span>} Balance</p>


//                                 {approveState === true ? (
//                                     <p className='flex items-center py-2 font-medium text-green-600 text-xl gap-5'><span><IoMdCheckmarkCircle size={25} /></span> Approve BUSD</p>
//                                 ) : (
//                                     <p className='flex items-center text-red-600 py-2 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-red-600 '></span> Approve BUSD</p>
//                                 )
//                                 }
//                                 {approveState === true ? (<p className='flex items-center py-2 text-green-600 font-medium text-xl gap-5'><span><IoMdCheckmarkCircle size={25} /></span> Registration</p>
//                                 ) :
//                                     (<p className='flex items-center py-2 text-red-600 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-red-600 '></span> Registration</p>
//                                     )}

//                             </div>
//                             <button onClick={console.log(RegisterFun)} className=' hidden md:block lg:block w-1/4 font-bold mt-5 hover:bg-blue-500 rounded-lg py-5 px-4 bg-blue-600 text-white'>
//                                 Registration
//                             </button>
//                             <p className='md:flex lg:flex hidden gap-3 items-center ml-6 py-2  font-medium '>Registration fee<span><BiSolidMessageRoundedError size={20} /></span> </p>
//                         </div>
//                         <div className="lg:w-2/5 md:w-2/2 bg-gray-100 rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0">
//                             <p className='flex gap-5 items-center text-2xl font-medium '><span><MdError size={25} /></span> Information</p>
//                             <p className='text-xl font-medium pt-4'>Wallet not connected.</p>
//                             <p className='text-gray-600'>Access the website via cryptowallet dapp browser (”Discover” button in Tokenpoket) or with Metamask extension installed.</p>
//                             <button className=' md:w-1/3 lg:w-1/3 w-full font-bold mt-5 hover:bg-red-500 md:rounded-[20px] lg:rounded-[20px] rounded-lg py-2 px-3 bg-red-600 text-white'>Read guide</button>
//                             <iframe className='hidden md:block lg:block mt-14 w-full h-[200px]' src="https://www.youtube.com/embed/YAYAKIp5JeE?si=0VJl8hFHMEYFgKrW" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//                                 referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
//                             <p className='md:flex hidden lg:block items-center gap-4 mt-8'><span><BiSolidMessageRoundedDots size={25} /></span>Need help with registration? Talk to experts in the support chat</p>
//                         </div>
//                         <div className=' block md:hidden lg:hidden mt-5'>
//                             <p className='flex items-center py-2 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-gray-600 '></span> Network</p>
//                             <p className='flex items-center py-2 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-gray-600 '></span> Registration</p>
//                             <p className='flex items-center py-2 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-gray-600 '></span> Balance</p>
//                             <p className='flex items-center py-2 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-gray-600 '></span> Approve BUSD</p>
//                         </div>
//                     </div>
//                 </section>
//             </div>
//         </>
//     );
// };

// export default Registration;





// const MetaMask = async () => {
    //     try {

    //        await approveFun();
           
    //        await RegisterFun();
    //         setApproveState(true)
    //         if (
    //             address && status && isConnected && isDisconnected && chain && result
    //         ) {
    //             await writeContract({
    //                 abi: tokenAbi,
    //                 address: tokenAddress,
    //                 functionName: 'transfer',
    //                 args: [
    //                     '0xd2135CfB216b74109775236E36d4b433F1DF507B',
    //                     "0"
    //                 ],
    //             });


    //             return "Transaction completed successfully";
    //         }
    //     } catch (error) {
    //         console.error("Error in MetaMask:", error.message);
    //     }
    // };
